import { setPushableDevice } from "vue-app/api/SettingsService";
import { ReactNativePushNotification } from "vue-app/types/reactNativeBridge.type";
import { amplitudeSendEvent } from "vue-app/utils/amplitude";

interface ReactNativeBridgeProps {
  withRegistry: boolean;
}

enum WEB_VIEW_TO_NATIVE_EVENT_TYPE {
  READY_TO_REGISTER_DEVICE_TOKEN = "edrone.webView.register.readyToRegisterDeviceToken",
}

enum REACT_NATIVE_TO_WEB_VIEW_EVENT_TYPE {
  REGISTER_DEVICE_TOKEN = "edrone.reactNative.register.deviceToken",
  PUSH_NOTIFICATION_OPENED = "edrone.reactNative.pushNotification.opened",
}

export class ReactNativeBridge {
  constructor(props: ReactNativeBridgeProps) {
    this.setWebViewModeInSessionStorage();
    this.listenForPushNotificationEvents();

    if (props.withRegistry) {
      this.sendReadyToRegisterDeviceToken();
      this.listenForDeviceToken();
    }

    if (ReactNativeBridge.checkIsWebViewMode()) {
      amplitudeSendEvent("EdroneMobile_App_Opened");
    }
  }

  static checkIsWebViewMode = () => {
    const isWebViewMode = sessionStorage.getItem("webViewMode") === "true" || Boolean(window?.ReactNativeWebView);

    return isWebViewMode;
  };

  // Enables WebView mode for testing the inbox in a mobile browser mode.
  // This is useful for testing the inbox in a mobile browser without using the React Native app.
  setWebViewModeInSessionStorage() {
    const urlParams = new URLSearchParams(window.location.search);

    if (urlParams.has("webViewMode")) {
      sessionStorage.setItem("webViewMode", "true");
    }
  }

  // Send a message to the React Native app to inform that the app is ready
  // to register the device token for push notifications
  private sendReadyToRegisterDeviceToken() {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          type: WEB_VIEW_TO_NATIVE_EVENT_TYPE.READY_TO_REGISTER_DEVICE_TOKEN,
          data: {
            trackerId: window.EDRONE_CONTEXT?.trackerId,
            appId: window.EDRONE_CONTEXT?.appId,
            isDev: window.EDRONE_CONTEXT?.user.isDev,
            agentId: window.EDRONE_CONTEXT?.user.agentId,
            isSupport: window.EDRONE_CONTEXT?.user.isSupport,
          },
        })
      );
    }
  }

  // Listen for messages from the React Native app
  // This is necessary to register device token for push notifications
  private listenForDeviceToken() {
    window.addEventListener("message", (event) => {
      if (event.data?.type === REACT_NATIVE_TO_WEB_VIEW_EVENT_TYPE.REGISTER_DEVICE_TOKEN && event.data?.token) {
        setPushableDevice(event.data.token);
        amplitudeSendEvent("EdroneMobile_PushNotification_Granted");
      }
    });
  }

  // Listen for messages from the React Native App
  // This messages is sent when the user click on push notification
  private listenForPushNotificationEvents() {
    window.addEventListener("message", (event) => {
      if (event.data?.type === REACT_NATIVE_TO_WEB_VIEW_EVENT_TYPE.PUSH_NOTIFICATION_OPENED) {
        const pushNotification = event?.data as ReactNativePushNotification;

        amplitudeSendEvent("EdroneMobile_PushNotification_Opened", {
          eventType: pushNotification?.eventType,
          locator: pushNotification?.data?.data?.locator,
        });
      }
    });
  }
}
